import React from 'react';
const ExternalLink: React.FC<React.HTMLProps<HTMLAnchorElement>> = ({
  target = '_blank',
  ...props
}) =>
// eslint-disable-next-line jsx-a11y/anchor-has-content
<a target={target} rel='noopener noreferrer' {...props} data-sentry-component="ExternalLink" data-sentry-source-file="index.tsx" />;
export default ExternalLink;